import { useStationCtx } from '@app/core/containers/StationCtx';
import { StationPageWrapper } from '@app/core/routing/StationPageWrapper';
import { PropsWithChildren } from 'react';
import { isAuditEnabled } from '../../../helpers';
import { AuditNotEnabledForStation } from './AuditNotEnabledForStation';

/**
 * Renders children when the current station has audit enabled; otherwise shows
 * AuditNotEnabledForStation. Must be used inside StationCtxProvider (e.g. under StationPage).
 */
function AuditStationGuard({ children }: PropsWithChildren) {
  const station = useStationCtx();

  if (!isAuditEnabled(station)) {
    return <AuditNotEnabledForStation station={station} />;
  }

  return <>{children}</>;
}

/**
 * Resolves station by slug from route params and ensures audit is enabled before rendering children.
 * Renders StationPageWrapper (not-found or context) then AuditStationGuard (audit check).
 */
export function AuditStationPage({ children }: PropsWithChildren) {
  return (
    <StationPageWrapper>
      <AuditStationGuard>{children}</AuditStationGuard>
    </StationPageWrapper>
  );
}
